import { combineReducers } from "redux";
import attendence from "../features/admin/attendence/Slice";

const AttendenceData = combineReducers({
  attendence: attendence,
});

export default AttendenceData;
